<template>
<header class="header">
    <div class="container">
        <router-link :to="{name: '/'}">
            <a href="#" class="header__left"><img src="/img/logo.svg" alt="" /></a>
        </router-link>
        <div class="header__right">
            <div class="header__right-inner">
                <button class="header__right-lauguage header__right-est">
                    <img src="/img/icon-estonia.svg" alt="" />
                </button>
                <button class="header__right-lauguage header__right-rus">
                    <img src="/img/icon-russia.svg" alt="" />
                </button>
            </div>
            <div class="header__right-item">
                <button class="header__right-openPr" @click="openOpenPr">открыть мою программу<span></span></button>
            </div>
        </div>
    </div>
</header>
</template>

<script>
export default {
    name: "header",
    methods: {
        openOpenPr() {
            this.$emit('enableDimming');
            this.$emit('headerModelOpen')
        },
    }
};
</script>

<style>
.header {
    margin-top: 34px;
    position: relative;
    z-index: 300;
}

.header .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header__right {
    display: flex;
    align-items: center;
}

.header__right-inner {
    position: relative;
}

.header__right-est {
    position: relative;
    z-index: 25;
}

.header__right-inner:before {
    content: '';
    position: absolute;
    background-image: url(/img/arrow-bottom.png);
    width: 8px;
    height: 6px;
    background-repeat: no-repeat;
    top: 50%;
    transform: translateY(-50%);
    right: -5px;
}

.header__right-inner:hover .header__right-rus {
    top: 100%;
}

.header__right-rus {
    position: absolute;
    top: 0%;
    left: 0;
    z-index: 20;
    transition: all .4s;
}

.header__right-openPr {
    background: -o-linear-gradient(top, #04c44c 0%, #20c05c 100%);
    background: linear-gradient(180deg, #04c44c 0%, #20c05c 100%);
    border-radius: 20.9362px;
    height: 44px;
    padding: 0 17px;
    font-size: 13px;
    text-transform: uppercase;
    margin-left: 37px;
    border: 1px solid #04c44c;
    position: relative;
    background-image: linear-gradient(45deg, #f1c40f 50%, #04c44c 50%);
    background-position: 100%;
    background-size: 400%;
    transition: all .7s;
}

.header__right-openPr:hover {
    background-position: 0;
    border: 1px solid #f1c40f;
    color: rgba(26, 23, 23, 0.8);
}

@media (max-width: 800px) {
    .header {
        margin-top: 26px;
    }

    .header__enter {
        max-width: 95%;
        height: 300px;
    }

    .header__enter-2 img {
        width: 105px;
    }

    .header__input {
        width: 70%;
    }
}

@media (max-width: 550px) {
    .header {
        margin-top: 6px;
    }

    .header__right-openPr {
        margin-left: 17px;
        width: 122px;
        padding: 0 11px;
        font-size: 11px !important;
    }

    .header__left img {
        padding-top: 9px;
        width: 90px;
    }

    .header {
        margin-top: 26px;
    }

    .header__enter {
        max-width: 95%;
        height: 250px;
    }

    .header__enter-2 img {
        width: 75px;
    }

    .header__input {
        width: 70%;
        height: 45px;
        font-size: 15px;
    }

    .header__input::placeholder {
        font-size: 15px;
    }

    .header__button {
        height: 42px;
        font-size: 18px;
    }

    .header__enter-3 {
        bottom: 24%;
    }

    .header__enter-3 img {
        width: 50px;
    }
}

@media (max-width: 400px) {
    .header__enter {
        height: 132px;
    }

    .header__input {
        height: 35px;
    }

    .header__enter-1 img {
        width: 60px;
    }

    .header__enter-2 img {
        height: 60px;
    }

    .header__enter-3 {
        bottom: 16%;
    }

    .header__enter-3 img {
        width: 30px;
    }

    .header__button {
        height: 23px;
        width: 90px;
        font-size: 14px;
        line-height: 23px;
    }
}
</style>
